import { render, staticRenderFns } from "./Alternativa.vue?vue&type=template&id=43eb1630&"
import script from "./Alternativa.vue?vue&type=script&lang=js&"
export * from "./Alternativa.vue?vue&type=script&lang=js&"
import style0 from "./Alternativa.vue?vue&type=style&index=0&id=43eb1630&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports